<template>
  <div>
    <h1>會員資料維護</h1>
    <table class="table table-hover">
      <thead class="thead-light">
      <tr>
        <th>ID <input class="form-control"  v-model="filters.id" @input="applyFilters" /></th>
        <th>姓名 <input class="form-control"  v-model="filters.name" @input="applyFilters" /></th>
        <th>電子郵件 <input class="form-control"  v-model="filters.email" @input="applyFilters" /></th>
        <th>密碼</th>
<!--        <th>狀態 <input class="form-control"  v-model="filters.status" @input="applyFilters" /></th>-->
        <th>手機號碼 <input class="form-control"  v-model="filters.mtel" @input="applyFilters" /></th>
        <th>地址1 <input class="form-control"  v-model="filters.address1" @input="applyFilters" /></th>
        <th>地址2 <input class="form-control"  v-model="filters.address2" @input="applyFilters" /></th>
        <th>性別 <input class="form-control"  v-model="filters.sex" @input="applyFilters" /></th>
        <th>已刪除 <input class="form-control"  type="checkbox" v-model="filters.deleted_at" @change="applyFilters" /></th>
        <th>操作</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(user, index) in filteredUsers" :key="index">
        <td>{{ user.id }}</td>
        <td><input class="form-control"  v-model="user.name" /></td>
        <td><input class="form-control"  v-model="user.email" /></td>
        <td><input class="form-control"  type="password" v-model="user.password" @input="user.passwordModified = true" /></td>
<!--        <td><input class="form-control"  v-model="user.status" /></td>-->
        <td><input class="form-control"  v-model="user.mtel" :disabled="isDuplicateMtel(user.mtel, user.id)" /></td>
        <td><input class="form-control"  v-model="user.address1" /></td>
        <td><input class="form-control"  v-model="user.address2" /></td>
        <td>
          <select class="form-control aselect" v-model="user.sex">
            <option value="m">善男</option>
            <option value="f">信女</option>
          </select>
        </td>
        <td><input class="form-check-input"  type="checkbox" v-model="user.deleted_at" /></td>
        <td>
          <button class="btn btn-primary" @click="saveUser(user)">儲存</button>
          <button class="btn btn-danger" @click="deleteUser(user)">刪除</button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import apiFireGodsec from "@/views/fireGods/js/apiFireGodsec";

export default {
  data() {
    return {
      users: [],
      filters: {
        id: '',
        name: '',
        email: '',
        status: '',
        mtel: '',
        address1: '',
        address2: '',
        sex: '',
        deleted_at: false
      }
    };
  },
  computed: {
    filteredUsers() {
      return this.users.filter(user => {
        return Object.keys(this.filters).every(key => {
          if (key === 'deleted_at') {
            return this.filters[key] ? user[key] : true;
          }
          return String(user[key]).includes(this.filters[key]);
        });
      });
    }
  },
  methods: {
    loadUsers() {
      apiFireGodsec.api_Admin_Users_List().then((response) => {
        this.users = response.data.data.map(user => ({ ...user, passwordModified: false }));
      });
    },
    saveUser(user) {
      apiFireGodsec.api_Admin_Users_Save(user).then((response) => {
        alert('儲存成功');
        this.loadUsers();
      });
    },
    deleteUser(user) {
      //show delete confirm
      if(confirm('確定要刪除嗎?')) {
        apiFireGodsec.api_Admin_Users_Delete(user).then((response) => {
          alert('刪除成功');
          this.loadUsers();
        });
      }
    },
    isDuplicateMtel(mtel, id) {
      return this.users.some(user => user.mtel === mtel && user.id !== id);
    },
    applyFilters() {
      // This method is intentionally left empty as the filtering is handled by the computed property
    }
  },
  mounted() {
    this.loadUsers();
  }
};
</script>

<style scoped>
.table {
  width: 100%;
}
input {
  width: 100%;
}
button {
  margin: 5px;
}
</style>
